import { connect } from 'react-redux'
import { RequestRow as RequestRowComponent } from './RequestRow'
import {
  setActiveRequest,
  fetchSingleCommsMessage,
} from 'store/MemberCommunication'

const mapStateToProps = ({ Member }) => ({
  members: Object.values(Member.members?.entities || {}),
})

const mapDispatchToProps = {
  setActiveRequest,
  fetchSingleCommsMessage,
}

export const RequestRow = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequestRowComponent)
